<div class="kt-grid kt-grid--hor kt-grid--root kt-login kt-login--v1 auth-page" id="kt_login">
	<div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--desktop kt-grid--ver-desktop kt-grid--hor-tablet-and-mobile w-100">
		<!--begin::Aside-->
		<div
			class="kt-grid__item kt-grid__item--order-tablet-and-mobile-2 kt-grid kt-grid--hor kt-login__aside bgi-style auth-left">
			<div class="kt-grid__item" class="uptime-logo" *ngIf="!hideUptimeBranding">
				<a href="javascript:;" class="kt-login__logo d-flex justify-content-around align-items-center">
					<img class="logo" [src]="imagePaths.uptimeAILogoWhite" *ngIf="isLogoAvailable" alt="uptime-logo" width="75em" />
				</a>
			</div>
			<div class="illustration-container d-flex align-items-center justify-content-center w-100 p-4 flex-grow-1">
				<div #lottieContainer class="auth-illustration" [style.display]="lottieLoaded ? 'block' : 'none'"></div>
				<img *ngIf="!lottieLoaded" class="auth-illustration" src="./assets/media/icons/svg/Auth/illustration.svg" alt="UptimeAI Illustration" />
			</div>
		</div>
		<!--begin::Aside-->

		<!--begin::Content-->
		<div class="kt-grid__item kt-grid__item--fluid  kt-grid__item--order-tablet-and-mobile-1 kt-login__wrapper login-page">
			<router-outlet></router-outlet>
		</div>
		<!--end::Content-->
	</div>
</div>
